(function () {
  const initAnimations = (section) => {
    if (!section || typeof gsap === "undefined") return;

    const container = section.querySelector(".block-animated-image-group");
    if (!container || container.dataset?.enableAnimation !== "true") return;

    const cards = gsap.utils.toArray(".block-image", section);
    if (!cards.length) return;

    const baseStrength = 10;
    const decay = 0.45;

    const initialTransforms = cards.map((card) => {
      const style = window.getComputedStyle(card);
      const matrix = new DOMMatrixReadOnly(
        style.transform === "none" ? "matrix(1,0,0,1,0,0)" : style.transform
      );
      return {
        x: matrix.m41 || 0,
        y: matrix.m42 || 0,
        rotation: Math.atan2(matrix.b, matrix.a) * (180 / Math.PI) || 0,
      };
    });

    gsap.set(cards, (i) => ({
      x: initialTransforms[i].x,
      y: initialTransforms[i].y,
      rotation: initialTransforms[i].rotation,
    }));

    let rafPending = false;
    let lastEvent = null;

    const onFrame = () => {
      rafPending = false;
      if (!lastEvent) return;

      const e = lastEvent;
      lastEvent = null;

      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;

      let hoveredIndex = 0;
      let minDist = Infinity;

      cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const centerX = r.left + r.width / 2;
        const d = Math.abs(e.clientX - centerX);
        if (d < minDist) {
          minDist = d;
          hoveredIndex = i;
        }
      });

      cards.forEach((card, i) => {
        const base = initialTransforms[i];
        const distance = Math.abs(i - hoveredIndex);
        const decayFactor = Math.pow(decay, distance);

        const moveX = (offsetX / baseStrength) * decayFactor;
        const moveY = (offsetY / baseStrength) * decayFactor * 1.25;

        const maxMove = 240;
        const clampedX = Math.max(-maxMove, Math.min(maxMove, moveX));
        const clampedY = Math.max(-maxMove, Math.min(maxMove, moveY));

        const targetX = base.x + clampedX;
        const targetY = base.y + clampedY;

        const tiltMax = 15;
        const normalizedX = offsetX / (rect.width / 2);
        const normalizedY = offsetY / (rect.height / 2);

        const tiltX = normalizedY * tiltMax * decayFactor;
        const tiltY = -normalizedX * tiltMax * decayFactor;

        gsap.to(card, {
          x: targetX,
          y: targetY,
          rotationX: tiltX,
          rotationY: tiltY,
          rotation: base.rotation + tiltY * 0.3,
          duration: 0.38,
          ease: "power2.out",
          overwrite: true,
        });
      });
    };

    const handleMouseMove = (e) => {
      lastEvent = e;
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(onFrame);
      }
    };

    const handleMouseLeave = () => {
      lastEvent = null;
      rafPending = false;

      cards.forEach((card, i) => {
        const base = initialTransforms[i];
        gsap.to(card, {
          x: base.x,
          y: base.y,
          rotationX: 0,
          rotationY: 0,
          rotation: base.rotation,
          duration: 0.8,
          ease: "elastic.out(1, 0.6)",
          overwrite: true,
        });
      });
    };

    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseleave", handleMouseLeave);

      gsap.killTweensOf(cards);
      cards.forEach((card) => card.removeAttribute("style"));
    };
  };

  const setupResponsiveAnimations = (section) => {
    let cleanup = null;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      const width = entry.contentRect.width;
      const isWide = width >= 750;
      const hasPointer = window.matchMedia("(pointer: fine)").matches;
      if (isWide && hasPointer) {
        if (!cleanup) {
          cleanup = initAnimations(section);
        }
      } else {
        if (cleanup) {
          cleanup();
          cleanup = null;
        }
      }
    });

    observer.observe(section);

    return () => {
      if (cleanup) cleanup();
      observer.disconnect();
    };
  };

  let teardown = null;
  let managedSection = null;

  const parentSection = document.currentScript.parentElement;
  if (
    parentSection &&
    parentSection.querySelector(".block-animated-image-group")
  ) {
    managedSection = parentSection;
    teardown = setupResponsiveAnimations(parentSection);
  }

  document.addEventListener("shopify:section:load", (event) => {
    const target = event.target;

    if (!managedSection || target !== managedSection) return;
    if (!target.querySelector(".block-animated-image-group")) return;

    if (teardown) teardown();

    managedSection = target;
    teardown = setupResponsiveAnimations(target);
  });
})();
